import Vue from 'vue'
import _ from 'lodash'
import * as types from '../../store/types'

const state = {}

const getters = {
    [types.preload.getters.item]: state => key => _.get(state, key)
}

const actions = {}

const mutations = {
    [types.preload.mutations.forgot] (state, key) {
        Vue.delete(state, key)
    },
    [types.preload.mutations.got] (state, preload) {
        _.extend(state, preload)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
